export default __webpack_public_path__ + "/assets/pdf_big.png";